/**
 * Created by intellicar-rinas on 7/11/17.
 */
import $ from 'jquery';
import ReactDOMServer from 'react-dom/server';
import React from 'react';
import './InfoWindow.css'
import hornImg from '../../../assets/images/horn.png';
import chargingIcon from '../../../assets/images/icon/charging.svg';
import dischargIcon from '../../../assets/images/icon/discharging.svg';
import charging_up from '../../../assets/images/icon/charging_up.svg';
import discharg_down from '../../../assets/images/icon/discharging_down.svg';
import moment from 'moment';
import CommandAPIs from '../../../APIs/CommandAPIs';
import ReportAPIs from '../../../APIs/ReportAPIs';
import {reqTracker} from '../../../helpers/apiHelper';
import { dateFormat } from '../../../constants/constants';
import _ from 'lodash';
import * as d3 from 'd3';
import axios from 'axios';

const timestampToString = (timestamp) => {
    if(!timestamp) return;

    if(isNaN(parseInt(timestamp))) {
        return timestamp;
    }

    return moment(timestamp).format('D MMM YYYY | HH:mm:ss')
};

const getFuelUnit =(val, data, vehicle)=> {
    let fueltype = vehicle && vehicle.vehiclemeta && vehicle.vehiclemeta.fueltype != 'EV' ? 'L' : 'v';
    if(!fueltype) fueltype = vehicle && vehicle.vehicleModel && vehicle.vehicleModel.fueltype != 'EV' ? 'L' : 'v';
    // if(fueltype === 'v' && !_.get(vehicle, 'stats.batteryVoltage')) return '%';
    if(fueltype === 'L' && vehicle.fueltankcapacity && vehicle.stats.fuelInLiters ){
        return fueltype;
    }
    else if(fueltype=== 'v'){
        return fueltype
    }
};

const getFuel2Unit =(val, data, vehicle)=> {
    return vehicle && vehicle.stats && vehicle.stats.fuel2InLiters !== undefined && vehicle.vehicleModel.fueltype != 'EV' ? 'L' : '%'
};

// #fuel
const getFuelInLiters =(val, data, vehicle)=> {
    if(_.get(vehicle, 'vehicleModel.fueltype') === 'EV') {
        let bv = _.get(vehicle, 'stats.batteryVoltage', '');
        if(bv != null){
            bv = bv.toFixed(2)
            // bv=parseFloat(bv)
             return bv;
        }else{
            return 0
        }
    }
    return val ? val : vehicle && vehicle.stats && vehicle.stats.fuelInLiters ? vehicle.stats.fuelInLiters :'';
};

const getFuel2InLiters =(val, data, vehicle)=> {
    return val ? val : vehicle && vehicle.stats && vehicle.stats.fuel2 ? vehicle.stats.fuel2 : val;
};

const getdevBatteryUnit =(val, data, vehicle)=> {

    if(!vehicle)
        return 'v';

    for(let idx in vehicle.devices) {
        if(vehicle.devices[idx].devicetype === 'concox_assettracker' ||
            vehicle.devices[idx].devicetype === 'concox_at4'){
            return '%';
        }
    }
    return 'v';
};

const processMILData =(val, data)=> {
    let markup = (
        <div className="mwdimil-box-inner">
            {(val && val.length ? val : ['No MIL']).map((item, index)=>{
                return <div className="mwdimil-box-item" key={index}>{item}</div>
            })}
            {data.DTC && data.DTC.millist.length > 0 && <div className="mwdimil-box-item">First observed on {moment(data.DTC.uts).format('D MMM YYYY HH:mm:ss')}</div>}
        </div>
    );
    return ReactDOMServer.renderToStaticMarkup(markup);
};

class InfoWindow {

    APIAndData = {
        getRTGPS: {api:ReportAPIs.getRTGPS, status:false, data:null, listeners:['speed', 'odo']},
        getRPMInfo: {api:ReportAPIs.getRPMInfo, status:false, data:null, listeners:['rpm']},
        getEngineTempInfo: {api:ReportAPIs.getEngineTempInfo, status:false, data:null, listeners:['enginetemp']},
        getFuelLevelInfo: {api:ReportAPIs.getFuelLevelInfo, status:false, data:null, listeners:['fuel']},
        getOdometerInfo: {api:ReportAPIs.getOdometerInfo, status:false, data:null, listeners:['odo']},
        getBatteryInfo: {api:ReportAPIs.getBatteryInfo, status:false, data:null, listeners:['carbattery', 'devbattery']},
        getSpeedInfo: {api:ReportAPIs.getSpeedInfo, status:false, data:null, listeners:['speed']},
        getHeadLightInfo: {api:ReportAPIs.getHeadLightInfo, status:false, data:null, listeners:['headlight']},
        getSeatBeltInfo: {api:ReportAPIs.getSeatBeltInfo, status:false, data:null, listeners:['seatbelt']},
        getACInfo: {api:ReportAPIs.getACInfo, status:false, data:null, listeners:['ac']},
        // getUserScore: {api:ReportAPIs.getUserScore, status:false, data:null, listeners:[]},
        // getAlarmHistory: {api:ReportAPIs.getAlarmHistory, status:false, data:null, listeners:[]},
        // getNanoBatteryInfo: {api:ReportAPIs.getNanoBatteryInfo, status:false, data:null, listeners:[]},
        // getRSSIInfo: {api:ReportAPIs.getRSSIInfo, status:false, data:null, listeners:[]},
        // getMagnetInfo: {api:ReportAPIs.getMagnetInfo, status:false, data:null, listeners:[]},
        // getAmbientLightInfo: {api:ReportAPIs.getAmbientLightInfo, status:false, data:null, listeners:[]},
    };

    historyData = {
        ac: {apis:[{name:'getACInfo', from:'value', to:'value'}]},
        seatbelt: {apis:[{name:'getSeatBeltInfo', from:'value', to:'value'}]},
        headlight: {apis:[{name:'getHeadLightInfo', from:'value', to:'value'}]},
        rpm: {apis:[{name:'getRPMInfo', from:'value', to:'value'}]},
        speed:  {apis:[{name:'getRTGPS', from:'speed', to:'value', priority:1}, {name:'getSpeedInfo', from:'value', to:'value', priority:2}]},
        enginetemp:  {apis:[{name:'getEngineTempInfo', from:'value', to:'value'}]},
        fuel:  {apis:[{name:'getFuelLevelInfo', from:'value', to:'value'}]},
        odo:  {apis:[{name:'getRTGPS', from:'odometer', to:'value', priority:1}, {name:'getOdometerInfo', from:'value', to:'value', priority:2}]},
        carbattery:  {apis:[{name:'getBatteryInfo', from:'carbattery', to:'value'}]},
        devbattery:  {apis:[{name:'getBatteryInfo', from:'devbattery', to:'value'}]},
    };

    // ac
    // seatbelt
    // headlight
    // speed
    // enginetemp
    // fuel
    // odo
    // carbattery
    // devbattery

    windowData = {};
    DOMData = {};
    keyToUIIDMap = [
        {key:'stats.speed',id:'dial_speed_val', default:0},
        {key:'stats.rpm',id:'dial_rpm_val', default:0},
        {key:'stats.rpm',id:'MWD_RPM', type: 'svg', SDA:180, max:7000},
        // {key:'stats.soh', id:'dial_rpm_val', default: 0}, // unhandled: both rpm & soh (being valid) coming together
        {key:'stats.gearposition',id:'dial_gear_val', default:'NA'},
        {key:'stats.enginetemp',id:'dial_temp_val', default:0},
        {key:'stats.enginetemp',id:'MWD_temp', type: 'svg', default:0,  SDA:85, max:120, processData:val=>{
            return Math.max(0, Math.min(120, parseInt(val, 10)));
        }},
        {key:'stats.dte',id:'dial_dte_val', default:0},
        {key:'stats.dte', id:'MWD_DTE', type: 'svg', default:0,  SDA:85, max:400, processData:val=>{
            return Math.max(0, Math.min(400, parseInt(val, 10)));
        }},
        {key:'stats.fuelInLiters',id:'dial_fuelraw_val', default:0, processData: getFuelInLiters},
        {key:'stats.fuel',id:'MWD_fuel', type: 'svg',  SDA:85, max:100, default:0, processData:val=>{
            return Math.max(0, Math.min(100, parseInt(val, 10)));
        }},
        {key:'stats.fuel',id:'dial_fuel_val', default:0},
        {key:'stats.test1',id:'dial_fuelunit_val', default:'', processData: getFuelUnit},
        {key:'stats.fuel2', id:'MWD_fuel2', type: 'svg', default:0,  SDA:85, max:100, processData:val=>{
            return Math.max(0, Math.min(100, parseInt(val, 10)));
        }},
        {key:'CAN.battmp', id:'bat_temp', type: 'svg', default:0,  SDA:85, max:100, processData:val=>{
            return Math.max(0, Math.min(100, parseInt(val, 10)));
        }},
        {key:'stats.fuel2InLiters',id:'dial_fuel2raw_val', default:0, processData: getFuel2InLiters},
        {key:'stats.fuel2',id:'dial_fuel2_val', default:0},
        // {key:'CAN.battmp',id:'dial_fuel2_val', default:0}, // incompatible, battmp can be not percent
        {key:'stats.test2',id:'dial_fuel2unit_val', default:'%', processData: getFuel2Unit},
        {key:'stats.carbattery',id:'dial_vehiclebattery_val', default:0},
        {key:'stats.devicebattery',id:'dial_devicebattery_val', default:0},
        //{key:'stats.batcurrent',id:'dial_devicebattery_val', default:0},
        {key:'stats.devicebatteryunit',id:'dial_devicebattery_unit', default:0, processData:getdevBatteryUnit},

        {key:'stats.lasttalkedtime',id:'dial_last_proctime', processData:timestampToString, default:'No Last Talked Time'},
        {key:'stats.canproctime',id:'dial_can_proctime', processData:timestampToString, default:'No CAN Proc Time'},
        {key:'stats.kletime',id:'dial_kle_proctime', processData:timestampToString, default:'No KLE Proc Time'},

        {key:'stats.gpstime',id:'dial_gps_time', processData:timestampToString, default:'No GPS Time'},
        {key:'stats.cantime',id:'dial_can_time', processData:timestampToString, default:'No CAN Time'},
        {key:'stats.kletime',id:'dial_kle_time', processData:timestampToString, default:'No KLE Time'},
        {key:'stats.fuelTime',id:'fueltime', processData: timestampToString},
        {key:'stats.fuelTime2',id:'fueltime2', processData: timestampToString},

        {key:'vehicleno',id:'dial_vehicle_vehicleno'},
        {key:'vehicleno', id:'dial_vehicle_chassisno'}, // In case chassi no is not updated
        {key:'vehiclemeta.chassisno',id:'dial_vehicle_chassisno'},
        {key:'stats.odometer',id:'dial_odometer', type:'odometer'},
        //{key:'CAN.chc',id:'dial_odometer', type:'odometer'},
        {key:'vehicleModel.model',id:'dial_vehicle_model'},
        {key:'vehiclemeta.fueltype',id:'dial_vehicle_fueltype', default:'P'},
        // {key:'vehicleModel.transmission',id:'dial_vehicle_transmission', default:'MT'},
        {key:'vehicleModel.variant',id:'dial_vehicle_variant'},
        {key:'devices.LOCK_UNLOCK.deviceno',id:'dial_vehicle_kledeviceno'},
        {key:'devices.TRACKER.deviceno',id:'dial_vehicle_deviceno'},
        {key:'stats.clutchPedal',id:'dial_clutch_pedal', type: 'pedal', processData:d=>{return Math.min(1, d) * 100}},
        {key:'stats.breakPedal',id:'dial_break_pedal', type: 'pedal', processData:d=>{return Math.min(1, d) * 100}},
        {key:'stats.accPedal',id:'dial_acc_pedal', type: 'pedal'},
        {key:'stats.millist',id:'dial_millist', processData:processMILData},
    ];


    uiStatusConfig = {
        ac:{
            0:"-white",
            1:"-yellow",
            'hide':"-transparent",
        },
        parkingbreak:{
            0:"-white",
            1:"-yellow",
            'hide':"-transparent",
        },
        mil:{
            0:"-white",
            1:"-blink",
            'hide':"-transparent",
        },
        indicator:{
            0:"-white",
            1:"-yellow",
            'hide':"-transparent",
        },
        seatbelt:{
            0:"-blink",
            1:"-yellow",
            'hide':"-transparent",
        },
        headlight:{
            0:"-white",
            1:"-yellow",
            'hide':"-transparent",
        },
        mobilistatus:{
            0:"-white",
            1:"-blink-slow",
            2:"-blinkOrange",
            3:"-blink",
            'hide':"-transparent",
        },
        doorlockstate:{
            0:"-white",
            1:"-yellow",
            'hide':"-transparent",
        },
        dooropenstate:{
            0:"-white",
            1:"-yellow",
            'hide':"-transparent",
        },
        carbattary:{
            0:"-white",
            1:"-yellow",
            'hide':"-transparent",
        },
        batteryHealthStatus:{
            0:"-white",
            1:"-blink",
            2:"-blinkOrange",
            4:"-yellow",
            6:"-green",
            'hide':"-transparent",
        },
    };

    constructor(ref, windowEvents, onPermUpdate, graphHandler,testing) {
        ['innerHTML', 'initEl', 'initIW', 'open', 'isValid', 'getEl', 'setContent', 'close', 'getDataFromChild',
            'getHistory', 'copyToClipboard', 'showHistory', 'mobilize', 'lock', 'honk', 'processJQEvent', 'updateUI',
            'getIndicatorStatus', 'showCANTime', 'showKLETime', 'mouseLeave', 'mouseEnter', 'checkCmdPerm',
            'checkDisplayMode', 'isCANTime', 'isCANOdo', 'triggerEvents', 'permUpdate', 'fetchHistoryData',
            'callAPIListeners', 'drawGraph', 'parseData', 'clearGraph', 'setGraphStatus', 'isEV', 'checkBatteryHealth',
            'isBatteryInfoAvailable','checkReportDisabled','isDataAvilable','checkLocshareEnable','shareLink'
        ]
            .map(i=>this[i]=this[i].bind(this));

        this.graphHandler = graphHandler && graphHandler.wrappedInstance ? graphHandler.wrappedInstance : graphHandler;
        this.initEl();
        this.initIW();
        this.windowEvents = windowEvents;
        this.onPermUpdate = onPermUpdate;

        window.onEscape('infoWindow', this.close);
        window.copyToClipboard = this.copyTextToClipboard;

        return this;
    }

    innerHTML() {
        return this.el ? this.el[0].innerHTML : '';
    }

    initIW() {
        this.iw = new window.google.maps.InfoWindow();

        const handleEvent = (e, tag) => {
            this.processJQEvent(e, tag);
        };

        this.iw.addListener('domready', function () {
            let iwOuter = $('.gm-style-iw');
            let iwBackground = iwOuter.prev();
            iwBackground.children(':nth-child(2)').css({'display': 'none'});
            iwBackground.children(':nth-child(4)').css({'display': 'none'});
            let iwCloseBtn = iwOuter.next();
            iwCloseBtn.css({display: "none"});

            $('[data-in-click]').click(e=>{
                handleEvent(e, 'click');
            });

            $('[data-in-mouseenter]').mouseenter(e=>{
                handleEvent(e, 'mouseenter');
            });

            $('[data-in-mouseleave]').mouseleave(e=>{
                handleEvent(e, 'mouseleave');
            });

        });

    }

    processJQEvent(e, tag) {
        let data = $(e.currentTarget).attr('data-in-'+tag);
        if(!data) return;
        data = data.split(":");

        if(data[0] in this) {
            this[data[0]](data[1], e);
        }
        this.updateUI();
    }

    getEl(id, callback=()=>{}, failed=()=>{}) {
        if(!this.isValid()) {
            failed();
            return;
        }
        let el = $('#'+id);
        if(el && el.length){
            callback(el[0]);
        }
        failed()
    }

    isValid() {
        return this.el != null && this.iw != null;
    }

    permUpdate(status) {
        this.vehiclePerm = status;
        if(this.onPermUpdate) {
            this.onPermUpdate(status);
        }
    }

    open(map, vehicle) {
        this.windowData = {};
        this.DOMData = {};
        this.selectedVehicle = vehicle;
        let marker = vehicle.marker;
        if(!this.isValid()) return;
        this.iw.setContent(this.innerHTML());
        this.iw.open(map, marker);
        this.permUpdate(null);
        let body = {
            vehicleid: this.selectedVehicle.vehicleid,
        };

        this.svg = $('#infovis')[0];
        this.graphHandler.init(this.svg);
        this.getHistory('speed');
        this.update({});
        this.updateUI();

        CommandAPIs.getVehCmdsPermList(body)
            .then((resp) => {
                // console.log(resp);
                this.permUpdate(resp);
                this.updateUI();
            }, (resp) => {
                this.permUpdate(null);
                this.updateUI();
                console.log("Permission fetching Failure");
            });
    }

    close() {
        if(!this.isValid()) return;
        for(let idx in this.historyData) {
            delete this.historyData[idx].data
        }
        for(let idx in this.APIAndData) {
            delete this.APIAndData[idx].data
        }
        if(window.openDial) {
            document.title = "Track"
            window.openDial = false
            
        }
        this.clearGraph();
        this.iw.close();
    }

    clearGraph(){
        // this.svg = $('#infovis')[0];
        if(this.graphHandler && this.svg && this.svg.length) {
            this.graphHandler.draw([{time:Date.now(), value:0}, {time:Date.now()+1, value:0}], 0, Date.now(), 1, this.svg, {name:''});
        }
    }

    setContent(data, value) {
        if(!this.isValid()) return;
        this.getEl(data.id, node=>{
            if(data.type === 'odometer') {
                let odoArr = (value+'').split('');
                let tempVal = 7 - odoArr.length;
                for(let idx=0; idx<tempVal; idx++){
                    odoArr.unshift('0');
                }
                for(let idx in odoArr) {
                    $(node).find('.mwdoi-' + (parseInt(idx, 10) + 1)).html(odoArr[idx]);
                }
            } else if(data.type === 'svg'){
                if(isNaN(value)){
                    value = 0;
                }
                let sda = (data.max - value) / data.max * data.SDA;
                $(node).attr('stroke-dashoffset', sda);
            } else if(data.type === 'pedal'){
                $(node).css('height', value + '%');
            } else {
                $(node).html(value);
            }
        });
    }

    getDataFromChild(data, keyString) {
        let key = keyString.split('.');
        if(key.length > 1) {
            let tempData = data;
            for(let idx in key) {
                if(!tempData || !(key[idx] in tempData)) {
                    return null;
                }
                tempData = tempData[key[idx]];
            }
            return tempData;
        }
        return data[key[0]];
    }



    update(data) {
        for(let idx in this.keyToUIIDMap) {
            let key = this.keyToUIIDMap[idx].key;
            let val = this.getDataFromChild(data, key);
            if(val == null && 'default' in this.keyToUIIDMap[idx]) {
                val = this.keyToUIIDMap[idx].default;
            }
            if(val != null) {
                if(this.keyToUIIDMap[idx].processData) {
                    val = this.keyToUIIDMap[idx].processData(val, data, this.selectedVehicle);
                }
                this.windowData[key] = val;

                // if(this.isBMS(this.selectedVehicle)) {
                //    if(key === 'stats.devicebattery') {

                //     } else this.windowData[key] = val;
                // } else {
                //     if(key === 'stats.batcurrent') {
                //     } else
                // }
            }
        }

        for(let key in this.windowData) {
            if(this.windowData[key] !== this.DOMData[key]) {
                this.DOMData[key] = this.windowData[key];
                for(let idx in this.keyToUIIDMap) {
                    if(this.keyToUIIDMap[idx].key === key) {
                        this.setContent(this.keyToUIIDMap[idx], this.DOMData[key])
                    }
                }
            }
        }

        // this.iw.setContent(this.innerHTML());
        this.updateUI();
    }

    getIndicatorStatus(tag) {
        if(this.selectedVehicle && this.selectedVehicle.stats) {
            if(tag in this.selectedVehicle.stats) {
                if(this.selectedVehicle.stats[tag] === 'NA') {
                    return null;
                }
                return this.selectedVehicle.stats[tag] == null ? 0 : this.selectedVehicle.stats[tag];
            } else {
                if(tag === 'batteryHealthStatus') {
                    if(tag in this.selectedVehicle) {
                        return this.selectedVehicle[tag] === -1 ? 0 : this.selectedVehicle[tag]
                    }
                    return 0;
                }
            }
        }
        return null;
    }



    updateUI() {

        let status = false;
        let vehicle = this.selectedVehicle;// eslint-disable-line
        let str;
        let vm = this;// eslint-disable-line

        let inIf = $('[data-in-if]');
        inIf.each((item)=>{
            str = $(inIf[item]).attr('data-in-if');
            try {
                status = eval(str);// eslint-disable-line
            } catch (e) {
                console.warn("Eval Failed", str);
                return null;
            }

            if(status) {
                $(inIf[item]).removeClass('--hide');
            } else {
                $(inIf[item]).addClass('--hide');
            }
        });

        let inIndicator = $('[data-in-indicator]');
        inIndicator.each((item)=>{
            str = $(inIndicator[item]).attr('data-in-indicator');
            if(this.uiStatusConfig[str]) {
                $(inIndicator[item]).removeClass('-white');
                $(inIndicator[item]).removeClass('-yellow');
                $(inIndicator[item]).removeClass('-blink');
                $(inIndicator[item]).removeClass('-blink-slow');
                $(inIndicator[item]).removeClass('-blinkOrange'); 
                if(this.getIndicatorStatus(str) !== null) {
                    $(inIndicator[item]).addClass(this.uiStatusConfig[str][this.getIndicatorStatus(str)]);
                }
            } else {
                console.log(str);
            }
        });

        let inClass = $('[data-in-class]');
        inClass.each((item)=>{
            str = $(inClass[item]).attr('data-in-class');
            if(!str) return;
            str = str.split(',');
            let condition;
            let status;
            for(let idx in str) {
                condition = str[idx].split(":");
                if(condition.length < 2) continue;
                status = false;
                try {
                    status = eval(condition[1]);// eslint-disable-line
                } catch (e) {
                    console.warn('Eval Failed: InClass', condition[1]);
                }

                if(status) {
                    $(inClass[item]).addClass(condition[0]);
                } else {
                    $(inClass[item]).removeClass(condition[0]);
                }
            }
        });

        if(this.isBMS(vehicle)) {
            function fillGuage(val) {
                let radius = 250 / 2;
                let border = 16;
                let twoPi = Math.PI * 2;
                let startAngle = 1;
                let endAngle = 1.21

                let arc = d3.arc()
                    .innerRadius(radius - border)
                    .outerRadius(radius)
                    .startAngle(twoPi * startAngle)
                    .endAngle(twoPi * endAngle);

                d3.select('#soh-c').attr('d', arc);

                let valAngle = endAngle;
                if(!isNaN(val)) {
                    let range = endAngle - startAngle;
                    val = Math.max(0, Math.min(val, 100))
                    let angle = (100 - val) / 100 * range;
                    valAngle = startAngle + angle;
                }
                arc.startAngle(twoPi * valAngle).endAngle(twoPi * endAngle)
                d3.select('#soh-v').attr('d', arc);
            }
            fillGuage(_.get(vehicle, 'stats.soh', 0));
        }
    }

    /*
    *
    *   Dial Methods
    *
    * */

    triggerEvents(source, params) {
        if(this.checkCmdPerm(source)) {
            this.windowEvents(source, params)
        }
    }


    parseData(data, key, starttime, endtime) {
        let arr = [];
        let limit = 1000;
        let skipperRatio = Math.ceil(data.length / limit);
        let counter = 0;
        let idx = 0;
        if(data.length > 0) {
            arr.push({time:starttime, value:data[0][key]});
            arr.push({time:data[0].time, value:data[0][key]});
            for(idx in data){
                if(counter === 0) {
                    arr.push({time:data[idx].time, value:data[idx][key]})
                }
                counter = counter === skipperRatio ? 0 : counter + 1;
            }
            arr.push({time:data[idx].time, value:data[idx][key]});
            arr.push({time:data[idx].time + 1, value:data[idx][key]});
            arr.push({time:endtime+2, value:data[idx][key]});
        }
        return arr;
    }


    drawGraph(data) {
        this.svg = $('#infovis')[0];
        let parsedData = this.parseData(data.values, data.api.from, data.starttime, data.endtime);
        this.graphHandler.draw(parsedData, 0, Date.now(), 1, this.svg, data.config);
        this.setGraphStatus('ACTIVE');
    }

    callAPIListeners(apiOBJ, tag, starttime, endtime) {
        for(let idx in apiOBJ.listeners) {
            if(this.historyData[apiOBJ.listeners[idx]]) {
                let hData = this.historyData[apiOBJ.listeners[idx]];
                let cAPI = null;

                for(let jdx in hData.apis) {
                    if(hData.apis[jdx].name === tag) {
                        cAPI = hData.apis[jdx];
                    }
                }

                if(!cAPI)
                    return;

                if(!hData.data || cAPI.name !== hData.tag || cAPI.priority >= hData.data.api.priority) {
                    hData.data = {
                        values: apiOBJ.data,
                        api: cAPI,
                        tag:apiOBJ.listeners[idx],
                        apiSource: tag,
                        starttime,
                        endtime,
                        config: {
                            name:apiOBJ.listeners[idx],
                            normalize: apiOBJ.listeners[idx] === 'odo' ? true : false,
                        }
                    };
                    if(this.historyRequested === apiOBJ.listeners[idx]) {
                        this.drawGraph(hData.data);
                    }
                }
            }
        }
    }


    fetchHistoryData(tag, callback) {
        if(tag in this.historyData) {
            this.historyRequested = tag;
            // if(this.historyData[tag].data) {
            //     callback(this.historyData[tag]);
            //     return;
            // }

            let body = {
                vehicleid:this.selectedVehicle.vehicleid,
                endtime:Date.now(),
                starttime:Date.now() - (1000 * 60 * 60 * 24),
            };

            let api;
            for(let idx in this.historyData[tag].apis) {
                api = this.historyData[tag].apis[idx];
                if(this.APIAndData[api.name] && this.APIAndData[api.name].data) {
                    this.callAPIListeners(this.APIAndData[api.name], api.name, body.starttime, body.endtime);
                } else {
                    reqTracker(this.APIAndData[api.name].api,body,api.name, (resp, key, status)=>{
                        if(status === 0)
                            return;

                        this.APIAndData[key].data = resp;
                        this.callAPIListeners(this.APIAndData[key], key, body.starttime, body.endtime);
                    });
                }
            }
        }

    }

    getHistory(tag) {
        this.triggerEvents('getHistory', tag);
        this.setGraphStatus('LOADING');
        this.fetchHistoryData(tag, data=>{
            console.log(data);
        });
    }

    copyToClipboard(tag, e) {
        this.copyTextToClipboard(e.currentTarget.innerText);
    }
    shareLink() {
        this.triggerEvents('shareLink')
    }
    openSettings() {
        this.windowEvents('showSettings');
    }
    getDtcReport() {
        this.windowEvents('showDTC');
    }

    showHistory() {
        window.setReportName = false
        this.triggerEvents('showHistory');
    }

    mobilize(status) {
        this.triggerEvents('immobilize', status);
        // console.log(status)
    }

    lock(status) {
        this.triggerEvents('lockunlock', status);
        // console.log(status)
    }

    honk() {
        this.triggerEvents('honk');
        // console.log('honk!')
    }

    showCANTime() {
        return this.dial_hover === 'CAN';
    }

    showKLETime() {
        return this.dial_hover === 'KLE';
    }

    mouseLeave(tag){
        this.dial_hover = null;
    }

    mouseEnter(tag) {
        this.dial_hover = tag;
    }

    isCANTime() {
        return this.selectedVehicle ? this.selectedVehicle.stats.cantime >= this.selectedVehicle.stats.gpstime : false;
    }

    isCANOdo() {
        return this.selectedVehicle && this.selectedVehicle.stats ? this.selectedVehicle.stats.odoSource === 'CAN' : false
    }

    nonPermMethods = ['showHistory','shareLink'];

    checkCmdPerm(tag) {
        return this.nonPermMethods.indexOf(tag) !== -1 ? true : this.vehiclePerm && this.vehiclePerm[tag] ? this.vehiclePerm[tag] : false;
    }
    checkLocshareEnable() {
        // if(window.userInfo){
        //     if(window.userInfo.SELF && window.userInfo.SELF.enable_share_loc) {
        //         return true
        //     }else return false
        // }
        return true;
    }

    checkDisplayMode(tag) {
        // return true;
    }
    checkReportDisabled(tag){
        let disabled_buttons = window.userInfo.SELF && window.userInfo.SELF.disabled_track_leftpane_buttons ? window.userInfo.SELF.disabled_track_leftpane_buttons : null ;
        return this.nonPermMethods == tag && disabled_buttons.includes('reports') ? true : false;
    }

    setGraphStatus(status) {
        this.graphStatus = status;
        this.updateUI();
    }

    copyTextToClipboard(text) {
        let textArea = document.createElement("textarea");

        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = 0;
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            let successful = document.execCommand('copy');
            let msg = successful ? 'successful' : 'unsuccessful';
            // console.log('Copying text command was ' + msg);
        } catch (err) {
            console.log('Oops, unable to copy');
        }
        document.body.removeChild(textArea);
    }

    canIShowTemp =(vehicle)=> {
        return !this.isEV(vehicle) && parseInt(vehicle.vehiclemeta.numfueltanks || 0, 10) <= 1
    }

    canIShowFuel2 =(vehicle)=> {
        return parseInt(vehicle.vehiclemeta.numfueltanks || 0, 10) > 1
    }

    isEV(vehicle) {
        return vehicle && vehicle.vehicleModel ? vehicle.vehicleModel.fueltype === 'EV' : false
    }
    isDataAvilable(vehicle) {
       if( vehicle.stats && vehicle.stats.dte && vehicle.stats.dte != null) return true;
    }

    isFuelHidden = () => {
        if(_.get(window.userInfo, 'SELF.hide_fuel') === 'HIDE') return true;
        return false;
    }

    checkBatteryHealth(vehicle, val) {
        return (vehicle.batteryHealthStatus || -1) === val;
    }

    isBatteryInfoAvailable(vehicle) {
        return vehicle.groupnames.indexOf('zoomcar') !== -1;
    }

    checkHistoryAvailable =(vehicle, tag)=> {
        return this.getIndicatorStatus(tag) !== 'hide';
    };

    isBMS = (vehicle) => {
        return _.get(vehicle, 'vehicleModel.vehicletype') === 'BMS';
    }
    isBCS = (vehicle) =>{
        return  _.get(vehicle, 'stats.bcs') != null;
    } 

    isCharging = (vehicle) => {
        return _.get(vehicle, 'stats.bcs') > 0;
    }

    /*
     *
     *   DOM
     *
     * */

    initEl() {
        this.el = $(ReactDOMServer.renderToString(
            <div>
                <div className="markerWindow">
                    <svg version="1.1" id="MWD_SVG" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
                        width="400px" height="240px" viewBox="0 0 400 240" enableBackground="new 0 0 400 240" >
                        <defs>
                            <linearGradient id="grad" x1="100%" y1="89%" x2="0%" y2="11%" >
                                <stop offset="0%" style={{stopColor:'rgb(87,255,109)',stopOpacity:1}} />
                                <stop offset="67%" style={{stopColor:'rgb(3,255,238)',stopOpacity:1}} />
                                <stop offset="100%" style={{stopColor:'rgb(3,255,238)',stopOpacity:1}} />
                            </linearGradient>
                        </defs>

                        {/*RPM*/}
                        <path data-in-if="!vm.isBMS(vehicle)" fill="none" stroke="#000000" strokeWidth="15" id="MWD_RPM_bg" d="M130.617,208.348c0,0-16.284-99.016-129.617-104.896"/>
                        <path data-in-if="!vm.isBMS(vehicle)" fill="none" stroke="#000000" strokeDashoffset="getRMP" strokeWidth="15" id="MWD_RPM" d="M130.617,208.348c0,0-16.284-99.016-129.617-104.896"/>
                        <path data-in-if="!vm.isBMS(vehicle)" fill="none" stroke="#000000" strokeWidth="15" id="MWD_RPM_hover" strokeMiterlimit="10" strokeDasharray="1.5" d="M130.617,208.348c0,0-16.284-99.016-129.617-104.896"/>
                        <path data-in-if="!vm.isBMS(vehicle)" className="path-trans" data-in-click="getHistory:rpm" fill="none" stroke="#000000" strokeWidth="15" d="M130.617,208.348c0,0-16.284-99.016-129.617-104.896"/>

                        <path data-in-if="!vm.isBMS(vehicle)" fill="none" stroke="#ffffff" strokeWidth="6"  id="MWD_RPM_ticks" strokeMiterlimit="20" strokeDasharray="1,22.4" d="M1,113.942c0,0,104-1.277,120.998,112.056"/>

                        <g data-in-if="vm.isBMS(vehicle)" transform="translate(10, 230)">
                            <path fill="#7f8995" id="soh-c"></path>
                            <path fill="#eee" id="soh-v"></path>
                        </g>

                        {/*FUEL*/}
                        <path id="MWD_fuel_bg" fill="none" stroke="#000000" strokeWidth="0.5" strokeMiterlimit="10" d="M39.899,90.354l0.469-5.605
                            c0,0,41.537,8.282,73.506,43.486l-3.731,4.119C110.143,132.354,82.118,100.49,39.899,90.354z" data-in-if="!vm.isFuelHidden()"/>
                        <path id="MWD_fuel" fill="none" stroke="#010101" strokeWidth="5.4" strokeDashoffset="getFuel"  strokeMiterlimit="10" d="M111.755,130.484c0,0-25.352-31.224-71.719-43.004" data-in-if="!vm.isFuelHidden()"/>
                        <path data-in-click="getHistory:fuel" className="path-trans" fill="#f00" stroke="#000000" strokeWidth="23" strokeMiterlimit="10" d="M39.899,90.354l0.469-5.605c0,0,41.537,8.282,73.506,43.486l-3.731,4.119C110.143,132.354,82.118,100.49,39.899,90.354z">
                            <title id="fueltime"></title>
                        </path>

                        {/*TEMP*/}
                        <path data-in-if="vm.canIShowTemp(vehicle)" id="MWD_temp_bg" fill="none" stroke="#010101" strokeWidth="0.5" strokeMiterlimit="10" d="M122.667,143.766l3.687-4.248c0,0,28.641,31.203,33.667,78.491l-5.444,1.122C154.577,219.131,150.762,176.868,122.667,143.766z"/>
                        <path data-in-if="vm.canIShowTemp(vehicle)" id="MWD_temp" fill="none" stroke="#010101" strokeWidth="5.4" strokeDashoffset="getTemp" d="M157.08,218.614c0,0-2.032-40.169-32.505-77.047"/>
                        <path data-in-if="vm.canIShowTemp(vehicle)" data-in-click="getHistory:enginetemp"  className="path-trans" fill="none" stroke="#010101" strokeWidth="23" strokeMiterlimit="10" d="M122.667,143.766l3.687-4.248c0,0,28.641,31.203,33.667,78.491l-5.444,1.122C154.577,219.131,150.762,176.868,122.667,143.766z"/>

                        {/*FUEL2*/}
                        <path data-in-if="vm.canIShowFuel2(vehicle)" id="MWD_fuel2_bg" fill="none" stroke="#010101" strokeWidth="0.5" strokeMiterlimit="10" d="M122.667,143.766l3.687-4.248c0,0,28.641,31.203,33.667,78.491l-5.444,1.122C154.577,219.131,150.762,176.868,122.667,143.766z"/>
                        <path data-in-if="vm.canIShowFuel2(vehicle)" id="MWD_fuel2" fill="none" stroke="#010101" strokeWidth="5.4" strokeDashoffset="getTemp" d="M157.08,218.614c0,0-2.032-40.169-32.505-77.047"/>
                        <path data-in-if="vm.canIShowFuel2(vehicle)" data-in-click="getHistory:fuel"  className="path-trans" fill="none" stroke="#010101" strokeWidth="23" strokeMiterlimit="10" d="M122.667,143.766l3.687-4.248c0,0,28.641,31.203,33.667,78.491l-5.444,1.122C154.577,219.131,150.762,176.868,122.667,143.766z">
                            <title id="fueltime2"></title>
                        </path>
                        {/*bms*/}
                        <path data-in-if="vm.isBMS(vehicle)" id="bat_temp_bg" fill="none" stroke="#010101" strokeWidth="0.5" strokeMiterlimit="10" d="M122.667,143.766l3.687-4.248c0,0,28.641,31.203,33.667,78.491l-5.444,1.122C154.577,219.131,150.762,176.868,122.667,143.766z"/>
                        <path data-in-if="vm.isBMS(vehicle)" id="bat_temp" fill="none" stroke="#010101" strokeWidth="5.4" strokeDashoffset="getTemp" d="M157.08,218.614c0,0-2.032-40.169-32.505-77.047"/>

                        {/*DTE*/}
                        <path data-in-if="vm.isEV(vehicle)" id="MWD_DTE_bg" fill="none" stroke="#010101" strokeWidth="0.5" strokeMiterlimit="10" d="M122.667,143.766l3.687-4.248c0,0,28.641,31.203,33.667,78.491l-5.444,1.122C154.577,219.131,150.762,176.868,122.667,143.766z"/>
                        <path data-in-if="vm.isEV(vehicle)" id="MWD_DTE" fill="none" stroke="#010101" strokeWidth="5.4" strokeDashoffset="getDTE" d="M157.08,218.614c0,0-2.032-40.169-32.505-77.047"/>
                        {/*<path data-in-if="vm.isEV(vehicle)" data-in-click="getHistory:dte"  className="path-trans" fill="none" stroke="#010101" strokeWidth="23" strokeMiterlimit="10" d="M122.667,143.766l3.687-4.248c0,0,28.641,31.203,33.667,78.491l-5.444,1.122C154.577,219.131,150.762,176.868,122.667,143.766z"/>*/}


                        <path className="mwd_pedal_frame" d="M71.447,214.393c-0.392-0.053-0.727-0.543-1.088-0.834c0.31-0.295,0.61-0.834,0.931-0.847
                            c1.941-0.075,3.889-0.071,5.83,0.015c0.317,0.017,0.609,0.574,0.913,0.881c-0.318,0.272-0.613,0.74-0.958,0.781
                            c-0.926,0.108-1.874,0.036-2.813,0.036c0,0.003,0,0.005,0,0.007C73.322,214.432,72.371,214.518,71.447,214.393z M60.382,220.646
                            c-1.892-0.076-3.79-0.076-5.682-0.004c-0.346,0.015-0.674,0.479-1.01,0.732c0.353,0.332,0.668,0.883,1.066,0.951
                            c0.852,0.148,1.748,0.046,2.629,0.046c0,0.024,0.001,0.054,0.002,0.08c1.012-0.05,2.036-0.025,3.031-0.185
                            c0.352-0.057,0.636-0.549,0.95-0.844C61.04,221.152,60.721,220.658,60.382,220.646z M71.57,218.395c1.741,0.117,3.5,0.117,5.241,0
                            c0.426-0.027,0.811-0.668,1.214-1.026c-0.448-0.32-0.862-0.831-1.352-0.918c-0.847-0.153-1.741-0.043-2.616-0.05
                            c-0.808,0-1.638-0.113-2.414,0.043c-0.481,0.099-0.877,0.611-1.312,0.938C70.743,217.734,71.136,218.363,71.57,218.395z
                             M77.051,220.462c-1.892-0.075-3.79-0.075-5.682-0.004c-0.346,0.015-0.674,0.479-1.01,0.733c0.353,0.332,0.668,0.883,1.066,0.951
                            c0.853,0.146,1.749,0.045,2.629,0.045c0,0.025,0.001,0.055,0.002,0.08c1.012-0.05,2.036-0.024,3.031-0.184
                            c0.352-0.057,0.636-0.549,0.95-0.844C77.709,220.968,77.39,220.475,77.051,220.462z M57.593,214.616c0-0.003,0-0.005,0-0.007
                            c0.939,0,1.887,0.072,2.813-0.036c0.345-0.041,0.64-0.509,0.958-0.781c-0.304-0.308-0.596-0.865-0.913-0.881
                            c-1.941-0.086-3.889-0.091-5.83-0.015c-0.321,0.013-0.621,0.552-0.931,0.847c0.361,0.291,0.696,0.78,1.088,0.834
                            C55.702,214.702,56.652,214.616,57.593,214.616z M54.901,218.579c1.741,0.116,3.5,0.116,5.241,0
                            c0.426-0.026,0.811-0.668,1.214-1.026c-0.448-0.32-0.862-0.83-1.352-0.918c-0.847-0.154-1.741-0.043-2.616-0.05
                            c-0.808,0-1.638-0.112-2.414,0.043c-0.481,0.099-0.877,0.61-1.312,0.938C54.074,217.92,54.467,218.549,54.901,218.579z M100.492,206
                            v27.5H50V206H100.492z M64.208,210.395c-0.018-1.461-0.776-2.365-2.411-2.345c-2.911,0.038-5.822,0.038-8.733-0.001
                            c-1.316-0.017-1.823,0.588-1.81,1.846c0.025,2.504,0.007,5.01,0.007,7.515c0,2.641,0.019,5.28-0.008,7.922
                            c-0.012,1.271,0.517,1.844,1.825,1.823c2.91-0.043,5.822-0.043,8.733-0.002c1.639,0.023,2.385-0.864,2.4-2.338
                            C64.261,220.007,64.266,215.202,64.208,210.395z M80.877,210.21c-0.018-1.46-0.776-2.364-2.411-2.344
                            c-2.911,0.038-5.822,0.038-8.733-0.001c-1.316-0.018-1.823,0.588-1.81,1.846c0.025,2.504,0.007,5.01,0.007,7.514
                            c0,2.641,0.019,5.281-0.008,7.922c-0.012,1.271,0.517,1.845,1.825,1.824c2.91-0.044,5.822-0.043,8.733-0.002
                            c1.639,0.023,2.385-0.865,2.4-2.339C80.93,219.823,80.935,215.018,80.877,210.21z M97.877,210.874
                            c-0.018-1.874-0.776-3.035-2.411-3.007c-2.911,0.049-5.822,0.05-8.733-0.002c-1.316-0.025-1.823,0.755-1.81,2.369
                            c0.025,3.213,0.007,6.427,0.007,9.641c0,3.391,0.019,6.777-0.008,10.165c-0.012,1.633,0.517,2.366,1.825,2.341
                            c2.91-0.055,5.822-0.054,8.733-0.002c1.639,0.031,2.385-1.109,2.4-3.001C97.93,223.211,97.935,217.043,97.877,210.874z
                             M94.051,224.031c-1.892-0.098-3.79-0.098-5.682-0.006c-0.346,0.02-0.674,0.613-1.01,0.941c0.353,0.426,0.668,1.133,1.066,1.221
                            c0.853,0.187,1.749,0.055,2.629,0.055c0,0.033,0.001,0.068,0.002,0.104c1.012-0.063,2.036-0.031,3.031-0.234
                            c0.352-0.069,0.636-0.702,0.95-1.082C94.709,224.68,94.39,224.049,94.051,224.031z M88.57,221.377c1.741,0.15,3.5,0.15,5.241,0
                            c0.426-0.036,0.811-0.857,1.214-1.318c-0.448-0.41-0.862-1.064-1.352-1.179c-0.847-0.194-1.741-0.054-2.616-0.062
                            c-0.808,0-1.638-0.146-2.414,0.056c-0.481,0.126-0.877,0.784-1.312,1.203C87.743,220.531,88.136,221.34,88.57,221.377z
                             M88.447,216.238c0.924,0.162,1.875,0.053,2.815,0.053c0-0.002,0-0.004,0-0.009c0.939,0,1.887,0.094,2.813-0.048
                            c0.345-0.053,0.64-0.65,0.958-1.002c-0.304-0.395-0.596-1.109-0.913-1.129c-1.941-0.111-3.889-0.117-5.83-0.021
                            c-0.321,0.018-0.621,0.707-0.931,1.086C87.72,215.542,88.055,216.172,88.447,216.238z"/>


                        {/*ICONS*/}
                        {/**/}
                        {/**/}
                        {/**/}
                        {/*AC*/}
                        <path  className="mwd_r_icon " data-in-indicator="ac"
                               xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd"
                               d="M18.935,48.36c0.764-1.813,1.52-3.61,2.277-5.405
                            c0.132-0.313,0.314-0.613,0.39-0.938c0.183-0.778,0.694-0.981,1.389-0.829c0.238,0.051,0.56,0.204,0.645,0.396
                            c0.961,2.199,1.882,4.416,2.812,6.628c0.017,0.042-0.007,0.1-0.014,0.15c-1.359,0.228-1.377,0.234-1.848-0.941
                            c-0.181-0.451-0.422-0.653-0.925-0.618c-0.624,0.044-1.254,0.034-1.88,0.002c-0.45-0.022-0.703,0.112-0.886,0.556
                            C20.393,48.579,20.37,48.569,18.935,48.36z M21.701,45.499c0.762,0,1.366,0,2.053,0c-0.341-0.802-0.642-1.506-1.024-2.402
                            C22.346,43.994,22.037,44.713,21.701,45.499z M30.903,47.685c-1.528,0.472-2.507,1.87-2.513,3.586
                            c-0.006,1.659,0.926,3.07,2.346,3.546c1.637,0.55,3.249,0.118,4.152-1.113c-0.69-0.978-0.703-0.981-1.452-0.453
                            c-1.009,0.714-2.025,0.608-2.878-0.3c-0.832-0.886-0.899-2.3-0.151-3.237c0.736-0.921,1.977-1.157,2.951-0.56
                            c0.985,0.604,0.985,0.604,1.632-0.356C34.139,47.614,32.542,47.179,30.903,47.685z M28.532,44.742
                            c-0.76,1.689-1.523,3.375-2.279,5.066c-0.538,1.199-1.068,2.403-1.602,3.606c0.911,0.286,1.35,0.004,1.689-0.811
                            c0.95-2.286,2.004-4.53,3.016-6.791c0.263-0.586,0.519-1.176,0.785-1.78C28.961,43.791,28.96,43.791,28.532,44.742z"/>


                        {/*Parking*/}
                        <path fill="#010101" className="mwd_r_icon " data-in-indicator="parkingbreak" d="M55.202,56.101c0.028-3.485,2.836-6.271,6.287-6.242c3.438,0.028,6.206,2.855,6.182,6.305
                            c-0.026,3.394-2.87,6.188-6.269,6.161C57.978,62.298,55.173,59.484,55.202,56.101z M61.42,60.754
                            c2.634-0.03,4.718-2.127,4.682-4.713c-0.036-2.575-2.151-4.638-4.728-4.611c-2.556,0.025-4.621,2.145-4.597,4.718
                            C56.8,58.683,58.914,60.782,61.42,60.754z M54.796,49.388c-0.508,0.575-0.938,1.209-1.304,1.881
                            c-0.997,1.848-1.418,3.809-1.157,5.902c0.193,1.547,0.738,2.974,1.544,4.301c0.343,0.569,0.733,1.109,1.111,1.675
                            c0.438-0.344,0.844-0.662,1.252-0.985c-0.05-0.069-0.089-0.121-0.129-0.172c-0.507-0.667-0.961-1.367-1.333-2.123
                            c-1.294-2.644-1.293-5.269,0.111-7.873c0.35-0.646,0.774-1.24,1.303-1.811c-0.388-0.349-0.772-0.693-1.164-1.05
                            C54.98,49.187,54.885,49.283,54.796,49.388z M67.818,62.998c0.78-1.015,1.44-2.101,1.917-3.292c0.616-1.539,0.866-3.133,0.678-4.782
                            c-0.192-1.675-0.794-3.202-1.748-4.586c-0.304-0.438-0.65-0.846-0.992-1.29c-0.395,0.406-0.748,0.776-1.109,1.153
                            c0.554,0.599,1.003,1.244,1.37,1.948c0.86,1.66,1.178,3.411,0.846,5.262c-0.271,1.492-0.924,2.821-1.784,4.055
                            c-0.16,0.23-0.33,0.453-0.503,0.69c0.407,0.32,0.806,0.634,1.221,0.96C67.759,63.067,67.791,63.034,67.818,62.998z M60.603,57.189
                            c0,0.708,0,1.386,0,2.074c-0.521,0-1.028,0-1.548,0c0-2.093,0-4.184,0-6.307c0.058,0,0.119,0,0.181,0c0.766,0,1.53-0.01,2.294,0.004
                            c0.311,0.008,0.631,0.036,0.93,0.112c1.139,0.286,1.534,1.138,1.425,2.175c-0.141,1.318-1.223,1.902-2.178,1.941
                            C61.349,57.202,60.99,57.189,60.603,57.189z M60.614,56.015c0.276,0,0.538,0.017,0.798-0.005c0.476-0.043,0.775-0.302,0.842-0.71
                            c0.022-0.134,0.023-0.274,0.013-0.411c-0.026-0.297-0.172-0.519-0.451-0.633c-0.386-0.161-0.79-0.119-1.201-0.122
                            C60.614,54.768,60.614,55.379,60.614,56.015z"/>


                        {/*MAL*/}
                        <path fillRule="evenodd" className="mwd_r_icon " data-in-indicator="mil" clipRule="evenodd" d="M84.012,72.851c0-1.67,0-3.34,0-5.011c0.212-0.5,0.349-0.589,0.901-0.589
                            c0.14,0,0.281-0.002,0.42,0c0.452,0.006,0.733,0.285,0.738,0.733c0.004,0.345,0.001,0.689,0.001,1.034c0,0.097,0,0.193,0,0.288
                            c0.251,0,0.475,0,0.711,0c0-0.456-0.003-0.898,0.001-1.341c0.004-0.428,0.291-0.712,0.716-0.713
                            c0.292-0.001,0.584-0.005,0.875,0.004c0.133,0.004,0.228-0.034,0.322-0.13c0.548-0.559,1.106-1.107,1.654-1.666
                            c0.188-0.192,0.401-0.281,0.669-0.281c2.459,0.004,4.917,0.002,7.375,0.003c0.521,0,0.785,0.266,0.785,0.787c0,1.045,0,2.09,0,3.135
                            c0,0.068,0,0.135,0,0.202c0.25,0,0.474,0,0.71,0c0-0.438-0.001-0.863,0.001-1.288c0.001-0.493,0.277-0.765,0.774-0.768
                            c0.128,0,0.257,0,0.385,0c0.552,0,0.689,0.089,0.902,0.589c0,1.67,0,3.34,0,5.011c-0.209,0.501-0.345,0.591-0.899,0.591
                            c-0.152,0-0.304,0.002-0.456-0.001c-0.41-0.009-0.692-0.284-0.704-0.694c-0.007-0.251-0.001-0.502-0.001-0.753
                            c0-0.202,0-0.404,0-0.609c-0.248,0-0.472,0-0.711,0c0,0.203-0.007,0.395,0.002,0.585c0.014,0.264-0.085,0.471-0.271,0.655
                            c-0.874,0.868-1.745,1.739-2.613,2.614c-0.19,0.191-0.402,0.276-0.671,0.275c-1.53-0.006-3.06-0.007-4.59,0
                            c-0.284,0.001-0.503-0.093-0.699-0.293c-0.548-0.559-1.107-1.107-1.656-1.664c-0.085-0.086-0.171-0.122-0.292-0.118
                            c-0.297,0.007-0.596,0.005-0.894,0.001c-0.43-0.006-0.709-0.288-0.712-0.718c-0.003-0.385-0.001-0.771-0.001-1.156
                            c0-0.061,0-0.123,0-0.18c-0.252,0-0.477,0-0.698,0c-0.006,0.025-0.012,0.036-0.012,0.047c-0.001,0.42,0,0.841-0.003,1.261
                            c-0.002,0.463-0.281,0.743-0.74,0.747c-0.14,0.001-0.28,0-0.42,0C84.356,73.441,84.22,73.352,84.012,72.851z M91.987,73.875
                            c0.013,0.006,0.025,0.014,0.039,0.021c1.03-1.296,2.059-2.592,3.116-3.922c-0.552,0-1.05,0-1.582,0
                            c0.565-0.933,1.115-1.84,1.681-2.772c-0.574,0-1.11,0.004-1.646-0.003c-0.128-0.001-0.195,0.035-0.253,0.152
                            c-0.531,1.077-1.068,2.15-1.604,3.225c-0.021,0.044-0.037,0.091-0.067,0.169c0.489,0,0.95,0,1.435,0
                            C92.725,71.808,92.356,72.841,91.987,73.875z M95.251,63.775c0.391,0,0.782,0.004,1.173-0.001c0.4-0.005,0.676-0.284,0.688-0.686
                            c0.005-0.192,0.001-0.385,0.001-0.578c-0.001-0.511-0.263-0.772-0.778-0.774c-0.729-0.002-1.459,0-2.188,0
                            c-0.828,0-1.657-0.003-2.485,0.001c-0.467,0.002-0.734,0.276-0.739,0.744c-0.001,0.204-0.006,0.408,0.002,0.612
                            c0.016,0.404,0.292,0.675,0.694,0.68c0.391,0.005,0.782,0.001,1.173,0.001c0.063,0,0.124,0,0.203,0c0,0.245,0,0.463,0,0.689
                            c0.69,0,1.363,0,2.053,0c0-0.231,0-0.45,0-0.689C95.125,63.775,95.189,63.775,95.251,63.775z"/>

                        {/*Indicator*/}
                        <path fillRule="evenodd" className="mwd_r_icon " data-in-indicator="indicator" clipRule="evenodd" d="M125.696,84.261c0-0.649-0.001-1.263,0-1.876c0-0.302,0.106-0.477,0.333-0.567
                            c0.221-0.088,0.416-0.025,0.627,0.198c1.843,1.94,3.687,3.879,5.531,5.818c0.34,0.357,0.341,0.577,0.007,0.927
                            c-1.792,1.881-3.583,3.761-5.375,5.642c-0.076,0.079-0.15,0.161-0.229,0.238c-0.159,0.155-0.34,0.222-0.559,0.137
                            c-0.226-0.087-0.331-0.264-0.333-0.494c-0.007-0.551-0.002-1.102-0.002-1.653c0-0.086,0-0.172,0-0.283
                            c-0.098-0.005-0.181-0.014-0.264-0.014c-1.031-0.001-2.062-0.001-3.093-0.002c-0.505-0.001-0.667-0.159-0.667-0.658
                            c-0.001-2.259-0.001-4.518-0.002-6.776c0-0.46,0.181-0.641,0.642-0.641c1.031,0.001,2.063,0.002,3.093,0.002
                            C125.492,84.261,125.577,84.261,125.696,84.261z M122.71,85.274c0,2.03,0,4.032,0,6.05c0.13,0,0.24,0,0.349,0
                            c0.993,0,1.985,0,2.977,0c0.534,0,0.697,0.17,0.689,0.711c-0.004,0.309,0,0.618,0,0.991c1.532-1.606,3.013-3.159,4.504-4.722
                            c-1.496-1.572-2.978-3.128-4.507-4.735c0,0.44,0.004,0.8-0.001,1.161c-0.006,0.343-0.208,0.539-0.546,0.544
                            c-0.125,0.002-0.252,0-0.378,0C124.774,85.274,123.751,85.274,122.71,85.274z M115.625,84.261c0.12,0,0.221,0,0.321,0
                            c1.008,0,2.016,0,3.023,0c0.54,0,0.704,0.187,0.701,0.729c-0.008,1.843-0.004,3.685-0.004,5.528c0,0.378,0.003,0.755,0,1.133
                            c-0.004,0.519-0.164,0.682-0.677,0.683c-1.016,0.003-2.032,0-3.047,0c-0.1,0-0.2,0-0.318,0c0,0.644-0.006,1.257,0.002,1.87
                            c0.003,0.261-0.066,0.465-0.322,0.571c-0.223,0.093-0.409,0.032-0.625-0.196c-1.802-1.894-3.604-3.788-5.406-5.681
                            c-0.065-0.068-0.131-0.137-0.194-0.207c-0.251-0.278-0.251-0.534,0.009-0.809c0.65-0.686,1.304-1.369,1.956-2.053
                            c1.211-1.271,2.424-2.542,3.635-3.812c0.027-0.028,0.053-0.058,0.083-0.084c0.159-0.142,0.338-0.201,0.543-0.114
                            c0.208,0.088,0.321,0.247,0.321,0.477c0,0.552,0,1.103-0.001,1.654C115.625,84.043,115.625,84.137,115.625,84.261z M114.616,83.632
                            c-0.019-0.005-0.038-0.01-0.057-0.015c-1.479,1.553-2.959,3.105-4.456,4.675c1.497,1.573,2.979,3.131,4.465,4.693
                            c0.024-0.035,0.04-0.046,0.04-0.059c0.003-0.33,0.003-0.661,0.005-0.991c0.003-0.436,0.182-0.614,0.618-0.614
                            c1.055,0,2.109,0,3.164,0.001c0.083,0,0.165,0,0.243,0c0-2.035,0-4.031,0-6.048c-0.088,0-0.165,0-0.241,0
                            c-1.055,0-2.109-0.001-3.164-0.002c-0.44,0-0.613-0.17-0.616-0.611C114.613,84.319,114.616,83.976,114.616,83.632z"/>


                        {/*Seatbelt*/}
                        <path fillRule="evenodd" className="mwd_r_icon  " data-in-indicator="seatbelt" clipRule="evenodd"
                              d="M146.195,110.129c-2.871-1.101-5.669-1.209-8.509-0.416
                            c-0.146-0.366-0.124-0.63,0.159-0.918c1.968-2.01,3.917-4.038,5.871-6.061c0.078-0.081,0.146-0.168,0.245-0.284
                            c-0.31-0.162-0.59-0.308-0.916-0.477c0.938-0.973,1.85-1.919,2.795-2.9c0.248,0.23,0.477,0.442,0.729,0.678
                            c-0.867,0.903-1.707,1.778-2.573,2.68c0.114,0.075,0.179,0.142,0.256,0.165c0.547,0.165,0.773,0.574,0.882,1.096
                            c0.347,1.682,0.723,3.357,1.047,5.043C146.264,109.153,146.195,109.601,146.195,110.129z M136.845,111.294
                            c0.448,1.616,1.157,3.124,1.937,4.601c0.063,0.119,0.189,0.254,0.311,0.283c0.482,0.115,0.974,0.191,1.532,0.294
                            c-0.077-0.184-0.127-0.309-0.18-0.433c-0.498-1.154-0.999-2.306-1.491-3.462c-0.217-0.51-0.111-0.711,0.416-0.821
                            c1.297-0.272,2.599-0.267,3.899-0.021c0.605,0.114,0.717,0.342,0.471,0.921c-0.256,0.601-0.524,1.197-0.783,1.797
                            c-0.282,0.652-0.559,1.305-0.862,2.014c0.541-0.094,1.009-0.159,1.467-0.266c0.136-0.032,0.293-0.156,0.357-0.281
                            c0.374-0.731,0.751-1.462,1.072-2.216c0.355-0.833,0.65-1.692,0.984-2.572c1.054,0.396,1.983,1.023,2.89,1.728
                            c0.208-0.258,0.399-0.494,0.603-0.745c-1.013-0.834-2.098-1.492-3.321-1.978c-0.081,0.338-0.154,0.64-0.229,0.955
                            c-3.065-1.207-6.083-1.195-9.167,0.015c-0.102-0.774-0.198-1.501-0.303-2.295c-1.08,1.119-2.131,2.208-3.19,3.307
                            c0.212,0.262,0.396,0.489,0.591,0.731c0.919-0.691,1.849-1.319,2.92-1.729C136.805,111.203,136.832,111.247,136.845,111.294z
                             M136.647,108.586c2.111-2.188,4.223-4.377,6.354-6.587c-0.133-0.077-0.208-0.125-0.287-0.164c-0.672-0.33-0.745-0.707-0.238-1.246
                            c0.851-0.903,0.928-2.242,0.184-3.161c-0.766-0.946-1.96-0.91-2.674,0.08c-0.675,0.936-0.576,2.188,0.243,3.075
                            c0.516,0.56,0.44,0.924-0.255,1.265c-0.622,0.305-1.247,0.604-1.851,0.939c-0.168,0.093-0.337,0.291-0.386,0.472
                            c-0.276,1.026-0.528,2.059-0.764,3.095c-0.165,0.722-0.291,1.452-0.434,2.178C136.575,108.551,136.61,108.568,136.647,108.586z"/>


                        {/*Headlight*/}
                        <path fillRule="evenodd" className="mwd_r_icon " data-in-indicator="headlight" clipRule="evenodd" d="M160.331,136.301c-0.169,0.493-0.5,0.769-1.025,0.774
                            c-0.863,0.008-1.734,0.073-2.589-0.014c-1.77-0.182-3.379-0.81-4.714-2.024c-1.553-1.416-1.988-3.373-1.14-5.148
                            c0.628-1.312,1.713-2.151,2.998-2.755c1.785-0.841,3.668-1.034,5.607-0.799c0.424,0.052,0.699,0.308,0.844,0.721
                            c0.528,1.503,0.845,3.04,0.823,4.682C161.163,133.281,160.842,134.807,160.331,136.301z M152.881,128.899
                            c-1.058,0.876-1.675,1.974-1.403,3.405c0.199,1.047,0.845,1.806,1.679,2.415c1.27,0.929,2.722,1.349,4.271,1.439
                            c0.562,0.032,1.13-0.018,1.693-0.059c0.111-0.009,0.275-0.127,0.312-0.23c0.978-2.781,0.976-5.566,0-8.348
                            c-0.035-0.099-0.179-0.209-0.285-0.225c-0.376-0.054-0.758-0.07-1.026-0.092C156.127,127.251,154.364,127.674,152.881,128.899z
                             M161.603,136.712c2.206,0,4.37,0,6.555,0c0-0.312,0-0.605,0-0.929c-0.125-0.009-0.236-0.021-0.347-0.021
                            c-1.857,0-3.715,0.006-5.572-0.006c-0.264-0.002-0.401,0.063-0.443,0.339C161.764,136.294,161.675,136.485,161.603,136.712z
                             M161.633,126.679c-0.008,0.038-0.015,0.05-0.012,0.061c0.24,0.883,0.24,0.883,1.147,0.883c1.699,0.001,3.399-0.003,5.098,0.01
                            c0.244,0.002,0.339-0.062,0.322-0.307c-0.014-0.204-0.003-0.411-0.003-0.646C165.977,126.679,163.811,126.679,161.633,126.679z
                             M162.224,134.426c2.005,0,3.961,0,5.932,0c0-0.313,0-0.606,0-0.929c-0.129-0.008-0.24-0.021-0.351-0.021
                            c-1.695,0-3.391,0.008-5.086-0.007c-0.28-0.002-0.399,0.085-0.417,0.354C162.29,134.018,162.253,134.21,162.224,134.426z
                             M168.175,132.139c0-0.263-0.001-0.501,0-0.742c0.001-0.247-0.184-0.188-0.322-0.188c-1.534-0.003-3.068-0.002-4.603-0.002
                            c-0.251-0.001-0.502,0-0.779,0c0,0.328,0,0.619,0,0.933C164.375,132.139,166.259,132.139,168.175,132.139z M162.214,128.929
                            c0.043,0.286,0.059,0.529,0.123,0.759c0.025,0.086,0.161,0.199,0.246,0.2c1.778,0.011,3.557,0.004,5.335,0.007
                            c0.193,0.001,0.266-0.066,0.26-0.262c-0.024-0.824,0.139-0.697-0.681-0.703c-1.617-0.009-3.234-0.001-4.851-0.001
                            C162.522,128.929,162.397,128.929,162.214,128.929z"/>


                        {/*Immobilize*/}
                        <path fillRule="evenodd" className="mwd_r_icon " data-in-indicator="mobilistatus"  clipRule="evenodd" d="M175.866,156.769c0.29-3.697,1.233-5.062,3.476-5.099
                            c2.256-0.038,3.17,1.258,3.551,5.034c1.825,0.457,1.837,0.472,1.837,2.366c0.001,1.222-0.022,2.443,0.008,3.665
                            c0.027,1.118-0.461,1.656-1.597,1.648c-2.485-0.018-4.97-0.032-7.453,0.006c-1.171,0.019-1.617-0.553-1.612-1.637
                            c0.005-1.304-0.006-2.605,0.001-3.909C174.085,157.224,174.235,157.052,175.866,156.769z M177.438,156.748c1.35,0,2.618,0,3.87,0
                            c0.347-2.921-0.557-3.485-1.914-3.576C177.902,153.075,177.297,154.211,177.438,156.748z M179.514,162.534
                            c0.193-0.207,0.496-0.383,0.547-0.613c0.15-0.675,0.293-1.377,0.253-2.058c-0.021-0.331-0.443-0.879-0.709-0.896
                            c-0.369-0.021-1.078,0.349-1.09,0.578c-0.044,0.87,0.111,1.754,0.258,2.621C178.793,162.295,179.16,162.367,179.514,162.534z
                             M173.766,162.284c-1.198,0-2.243,0-3.298,0c-0.38,0.916,0.205,2.423-1.447,2.279c-1.293-0.113-0.87-1.229-0.977-2.101
                            c-0.356-0.095-0.728-0.192-1.16-0.307c0-1.329-0.033-2.632,0.021-3.93c0.016-0.367,0.187-0.901,0.457-1.052
                            c1.051-0.587,1.235-1.667,1.634-2.61c0.794-1.878,0.767-1.891,2.818-1.926c0.201-0.004,0.401-0.019,0.663-0.031
                            c0.079-0.366,0.153-0.71,0.257-1.192c0.447,0,0.88,0,1.314,0c0.447,0,0.894,0,1.282,0c0.273,0.485,0.679,0.903,0.691,1.332
                            c0.008,0.287-0.518,0.808-0.847,0.845c-1.005,0.113-2.038,0.112-3.049,0.024c-1.203-0.104-1.958,0.24-2.151,1.525
                            c-0.063,0.426-0.298,0.824-0.524,1.42c1.562,0,2.993,0,4.315,0C173.766,158.538,173.766,160.349,173.766,162.284z M170.604,158.939
                            c-0.597-0.514-0.95-1.053-1.326-1.069c-0.318-0.016-0.878,0.547-0.928,0.909c-0.041,0.297,0.482,0.918,0.806,0.955
                            C169.524,159.777,169.947,159.327,170.604,158.939z M178.479,155.878c0.229,0.823,0.768,0.739,1.509,0.492
                            c-0.354-0.913-0.681-1.753-1.046-2.692C177.522,154.323,178.272,155.14,178.479,155.878z"/>



                        {/*DOOR LOCK STATE*/}
                        <path fillRule="evenodd" className="mwd_r_icon " data-in-indicator="doorlockstate" clipRule="evenodd" d="M181.02,184.175c0-0.4-0.019-0.777,0.004-1.15
                            c0.082-1.371,0.491-2.617,1.524-3.574c2.342-2.168,6.066-1.277,7.192,1.685c0.262,0.688,0.413,1.395,0.404,2.133
                            c-0.003,0.297,0,0.594,0,0.907c0.229,0,0.442-0.002,0.656,0c0.409,0.002,0.699,0.289,0.699,0.696c0.002,2.163,0.002,4.325,0,6.488
                            c0,0.415-0.292,0.706-0.708,0.707c-3.473,0-6.946,0-10.419,0c-0.42-0.001-0.71-0.289-0.71-0.704c-0.001-2.163-0.001-4.326,0-6.488
                            c0-0.408,0.288-0.697,0.696-0.699C180.574,184.173,180.789,184.175,181.02,184.175z M182.66,184.162c1.956,0,3.899,0,5.845,0
                            c0-0.363,0.01-0.712-0.002-1.061c-0.018-0.495-0.119-0.976-0.302-1.438c-0.453-1.141-1.472-1.87-2.662-1.829
                            c-1.204,0.041-2.057,0.647-2.546,1.752C182.628,182.408,182.628,183.279,182.66,184.162z"/>


                        {/*DOOR OPEN STATE*/}
                        <path fillRule="evenodd" className="mwd_r_icon " data-in-indicator="dooropenstate" clipRule="evenodd" d="M186.395,218.005c0.425,0,0.82,0,1.243,0c0-0.439-0.039-0.866,0.011-1.28
                            c0.05-0.423-0.1-0.756-0.295-1.099c-0.249-0.439-0.478-0.89-0.703-1.341c-0.055-0.109-0.083-0.244-0.083-0.368
                            c-0.007-1.375-0.01-2.748-0.001-4.123c0-0.107,0.072-0.243,0.155-0.317c0.29-0.257,0.596-0.499,0.904-0.735
                            c0.578-0.447,1.245-0.673,1.967-0.699c0.637-0.022,1.278-0.022,1.914,0.021c0.861,0.061,1.539,0.525,2.215,1.031
                            c0.477,0.355,0.625,0.745,0.599,1.321c-0.046,1.035-0.029,2.074,0,3.111c0.013,0.433-0.1,0.806-0.304,1.172
                            c-0.271,0.488-0.531,0.981-0.789,1.477c-0.033,0.063-0.042,0.145-0.043,0.219c-0.004,0.524-0.002,1.049-0.002,1.602
                            c0.457,0,0.858,0,1.276,0c0.011,0.092,0.027,0.156,0.027,0.222c0,1.322,0.009,2.645-0.006,3.967
                            c-0.016,1.369-1.096,2.644-2.458,2.761c-1.061,0.092-2.143,0.09-3.203-0.002c-1.329-0.113-2.423-1.422-2.432-2.76
                            c-0.009-1.314-0.004-2.628-0.004-3.941C186.38,218.175,186.388,218.107,186.395,218.005z M191.979,219.274
                            c-0.006-0.098-0.014-0.166-0.014-0.233c-0.001-0.838-0.017-1.676,0.007-2.513c0.009-0.309-0.043-0.625,0.137-0.93
                            c0.318-0.539,0.593-1.104,0.878-1.663c0.045-0.088,0.072-0.195,0.073-0.294c0.005-1.09,0.006-2.179-0.002-3.268
                            c0-0.095-0.059-0.211-0.129-0.277c-0.553-0.528-1.216-0.795-1.981-0.836c-1.083-0.06-2.127-0.002-2.984,0.797
                            c-0.122,0.112-0.167,0.215-0.166,0.372c0.005,1.038-0.002,2.075,0.007,3.113c0.002,0.156,0.043,0.323,0.112,0.464
                            c0.282,0.575,0.584,1.14,0.873,1.712c0.044,0.088,0.079,0.192,0.081,0.288c0.016,0.994,0.025,1.988,0.034,2.98
                            c0,0.093-0.009,0.185-0.014,0.292c-0.431,0-0.833,0-1.262,0c0,0.103,0,0.187,0,0.271c0,0.82,0,1.642,0,2.464
                            c0,0.979,0.722,1.731,1.695,1.748c0.744,0.013,1.487,0.013,2.23,0.001c0.852-0.014,1.641-0.698,1.67-1.505
                            c0.035-0.975,0.005-1.953,0.002-2.93c0-0.014-0.02-0.027-0.041-0.055C192.8,219.274,192.404,219.274,191.979,219.274z
                             M194.124,215.256c-0.08,0.145-0.066,0.237,0.048,0.359c0.444,0.477,0.868,0.974,1.316,1.448c0.222,0.235,0.41,0.534,0.825,0.484
                            c0.238-0.029,0.405-0.149,0.465-0.332c0.064-0.196,0.114-0.433-0.062-0.63c-0.389-0.435-0.768-0.878-1.157-1.313
                            c-0.292-0.326-0.596-0.645-0.924-0.998C194.456,214.624,194.298,214.944,194.124,215.256z M185.553,215.022
                            c-0.443,0.479-0.891,0.955-1.333,1.437c-0.22,0.241-0.281,0.715,0.059,0.979c0.223,0.175,0.587,0.144,0.842-0.118
                            c0.202-0.209,0.396-0.427,0.592-0.642c0.341-0.375,0.683-0.748,1.019-1.128c0.038-0.043,0.069-0.134,0.048-0.176
                            c-0.173-0.357-0.359-0.71-0.557-1.092C185.981,214.552,185.769,214.788,185.553,215.022z M188.19,212.206
                            c0.025,0.765-0.155,1.535,0.347,2.215c0.088,0.119,0.152,0.185,0.301,0.167c1.06-0.122,2.12-0.12,3.181-0.003
                            c0.072,0.008,0.194,0.008,0.215-0.031c0.157-0.294,0.374-0.587,0.422-0.903c0.071-0.464,0.019-0.946,0.019-1.444
                            C191.164,211.91,189.686,211.902,188.19,212.206z M188.57,219.932c-0.011,0.035-0.025,0.059-0.025,0.083
                            c-0.001,0.569-0.01,1.14-0.001,1.71c0.009,0.56,0.396,0.969,0.958,0.986c0.622,0.021,1.245,0.02,1.866,0
                            c0.526-0.016,0.931-0.408,0.947-0.916c0.019-0.612,0.004-1.226,0.004-1.863C191.052,219.932,189.812,219.932,188.57,219.932z"/>


                        {/*Battery Icons*/}

                        {/*Car Battery*/}
                        <path fillRule="evenodd"  className="mwd_r_icon -white"  data-in-click="getHistory:carbattery" data-in-indicator="batteryHealthStatus"
                              clipRule="evenodd" d="M247.33,225.985c4.611,0,9.172,0,13.76,0c0.006,0.12,0.016,0.226,0.016,0.331
                            c0.002,2.445,0.002,4.892,0.001,7.338c0,0.539-0.155,0.688-0.705,0.688c-4.116,0-8.233,0-12.351,0c-0.563,0-0.721-0.156-0.721-0.71
                            c0-2.435,0-4.87,0-7.306C247.33,226.22,247.33,226.113,247.33,225.985z M255.201,226.716c-0.021-0.009-0.043-0.017-0.064-0.024
                            c-0.948,1.41-1.896,2.82-2.883,4.287c0.608-0.1,1.145-0.188,1.725-0.281c-0.384,0.998-0.749,1.949-1.114,2.899
                            c0.015,0.007,0.028,0.015,0.042,0.022c1.088-1.426,2.176-2.852,3.296-4.322c-0.731,0.119-1.391,0.226-2.101,0.34
                            C254.48,228.629,254.841,227.672,255.201,226.716z M250.322,223.597c-0.949,0-1.898-0.001-2.848,0.001
                            c-0.394,0-0.471,0.08-0.473,0.479c-0.001,0.272,0,0.546,0,0.818c0,0.513,0.072,0.587,0.576,0.587c4.354,0,8.709,0,13.063,0
                            c0.12,0,0.24,0.003,0.36-0.002c0.352-0.012,0.449-0.104,0.457-0.447c0.008-0.328,0.008-0.655,0.002-0.982
                            c-0.008-0.355-0.113-0.453-0.48-0.453c-0.939-0.002-1.877-0.001-2.816-0.001c-0.113,0-0.229,0-0.354,0
                            c0-0.347-0.002-0.642,0.001-0.937c0.003-0.296-0.136-0.441-0.437-0.439c-0.469,0.004-0.938,0.001-1.407,0.001
                            c-1.615,0-3.23-0.001-4.846,0.001c-0.385,0-0.454,0.072-0.456,0.457c-0.001,0.293,0,0.585,0,0.917
                            C250.518,223.597,250.42,223.597,250.322,223.597z M249.074,221.9l-0.418-0.016c0,0-0.377-0.033-0.378,0.336l-0.013,0.188
                            c0,0,0.017,0.034-0.09,0.071c0,0-0.219,0.089-0.195,0.4c0.002,0.043,0.012,0.31,0.012,0.31h1.082V221.9z M248.962,223.19h1.082
                            c0,0,0.009-0.267,0.012-0.31c0.022-0.312-0.196-0.4-0.196-0.4c-0.105-0.037-0.09-0.071-0.09-0.071l-0.012-0.188
                            c-0.002-0.369-0.377-0.336-0.377-0.336l-0.419,0.016V223.19z M259.561,221.9l-0.418-0.016c0,0-0.377-0.033-0.378,0.336l-0.013,0.188
                            c0,0,0.017,0.034-0.09,0.071c0,0-0.219,0.089-0.195,0.4c0.002,0.043,0.012,0.31,0.012,0.31h1.082V221.9z M259.447,223.19h1.083
                            c0,0,0.009-0.267,0.012-0.31c0.022-0.312-0.196-0.4-0.196-0.4c-0.105-0.037-0.09-0.071-0.09-0.071l-0.012-0.188
                            c-0.002-0.369-0.377-0.336-0.377-0.336l-0.42,0.016V223.19z"/>

                        <path   className="mwd_r_icon -white"  data-in-click="getHistory:devbattery"
                                fillRule="evenodd" clipRule="evenodd" d="M374.752,230.419c-0.45,0-0.902,0-1.409,0c0,0.769,0,1.517,0,2.307
                            c-0.704,0-1.351,0-1.999,0c-5.595-0.001-11.189-0.001-16.784-0.001c-0.08,0-0.159,0.005-0.239,0.009c0-2.981,0-5.959,0-8.939
                            c3.348,0.003,6.695,0.006,10.041,0.009c2.844,0.001,5.686,0,8.528,0.001c0.129,0,0.26,0,0.436,0c0,0.772,0,1.509,0,2.304
                            c0.507,0,0.969,0,1.427,0C374.752,227.544,374.752,228.982,374.752,230.419z M355.092,224.593c0,2.474,0,4.898,0,7.324
                            c5.844,0,11.658,0,17.475,0c0-2.461,0-4.886,0-7.324C366.731,224.593,360.925,224.593,355.092,224.593z"/>
                        
                        <rect width="15" fill="#fff" y="226" height="5" x="356"></rect>
                    </svg>


                    <svg version="1.1" id="MWD_steering" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
                         width="21.797px" height="21.775px" viewBox="0 0 21.797 21.775" enableBackground="new 0 0 21.797 21.775" >
                        <path fillRule="evenodd" clipRule="evenodd" d="M9.819,19.644c-5.424,0-9.823-4.407-9.819-9.837C0.004,4.393,4.413-0.003,9.833,0
                            c5.422,0.003,9.817,4.414,9.811,9.846C19.637,15.25,15.231,19.644,9.819,19.644z M2.93,7.357c4.603,0,9.192,0,13.787,0
                            c-0.901-2.659-3.558-4.925-6.938-4.901C6.27,2.479,3.738,4.902,2.93,7.357z M8.57,17.048c0.033-0.515-0.131-1.618-0.327-2.276
                            c-0.392-1.316-1.043-2.477-2.054-3.417c-0.868-0.808-1.885-1.314-3.06-1.487C2.91,9.835,2.686,9.835,2.463,9.822
                            C2.441,13.408,5.125,16.489,8.57,17.048z M17.176,9.787c-0.438,0.068-0.87,0.102-1.281,0.208c-1.462,0.382-2.572,1.27-3.421,2.492
                            c-0.817,1.176-1.241,2.497-1.379,3.916c-0.02,0.209-0.021,0.424-0.031,0.638C14.436,16.543,17.229,13.425,17.176,9.787z
                             M9.822,8.596c-0.674,0-1.227,0.555-1.226,1.229c0.002,0.668,0.548,1.217,1.217,1.224c0.674,0.003,1.231-0.549,1.234-1.224
                            C11.05,9.15,10.498,8.597,9.822,8.596z"/>
                    </svg>

                    {/* Pedal Status */}
                    <div className="mwd_peddleProgress">
                        <div className="mwd_peddlebar" id="dial_clutch_pedal" style={{height: "dial.getPedalStatus('clutchPedal')%"}}></div>
                    </div>

                    <div className="mwd_peddleProgress -middle">
                        <div className="mwd_peddlebar" id="dial_break_pedal"  style={{height: "dial.getPedalStatus('breakPedal')%"}}></div>
                    </div>

                    <div className="mwd_peddleProgress -right">
                        <div className="mwd_peddlebar" id="dial_acc_pedal"  style={{height: "dial.getPedalStatus('accPedal')%"}}></div>
                    </div>



                    {/*SPEED*/}
                    <div className="mwd_speed" data-in-click="getHistory:speed">
                        <span id="dial_speed_val"></span>
                        <span className="unit">KMPH</span>
                    </div>

                    {/*RPM*/}
                    <div className="mwd_rpmRaw" data-in-click="getHistory:rpm">
                        <span id="dial_rpm_val"></span>
                        <span className="rpm_unit">RPM</span>
                        {/* <span className="rpm_unit" data-in-if="vm.isBMS(vehicle)">SOH</span> */}
                    </div>

                    {/*CHARGING STATE*/}
                    <div className="mwd_charge" data-in-if="(vm.isBMS(vehicle) && vm.isBCS(vehicle))">
                        <img src={chargingIcon} data-in-if="vm.isCharging(vehicle)" />
                        <img src={dischargIcon} data-in-if="!vm.isCharging(vehicle)" />
                        <div className='mwdc_cstate' data-in-if="vm.isCharging(vehicle)"><img src={charging_up} /></div>
                        
                        <div className='mwdc_dstate' data-in-if="!vm.isCharging(vehicle)"><img src={discharg_down} /></div>
                    </div>

                    {/*GEAR*/}
                    <div className="mwd_gear" data-in-if="!vm.isBMS(vehicle)">
                        {/*<span ngShow="dial.getGear() == 'NA'" className="-small">/!*getGear*!/</span>*/}
                        <span className="-small">
                            <span id="dial_gear_val"></span>
                        </span>
                    </div>

                    {/*Temperature Raw*/}
                    <div data-in-if="vm.canIShowTemp(vehicle)" className="mwd_temperature" data-in-click="getHistory:enginetemp">
                        <span id="dial_temp_val"></span><span className="mwdt_unit">{String.fromCharCode(8451)}</span>
                    </div>


                    {/*Fuel 2 Raw*/}
                    <div className="mwd_temperature" data-in-if="vm.canIShowFuel2(vehicle)"  data-in-click="getHistory:fuel" >
                        <span id="dial_fuel2raw_val"></span><span><span id="dial_fuel2unit_val"></span></span>
                    </div>

                    {/*DTE Raw*/}
                    <div className="mwd_temperature" data-in-if="vm.isEV(vehicle)">
                        <span data-in-if= "vm.isDataAvilable(vehicle)"><span  id="dial_dte_val"></span><span  className="mwdt_unit"> km</span></span>
                    </div>

                    {/*Fuel Raw*/}
                    <div className="mwd_fuel" data-in-click="getHistory:fuel" data-in-if="!vm.isFuelHidden()">
                        <span id="dial_fuelraw_val"></span><span><span id="dial_fuelunit_val"></span></span>
                    </div>

                    <div className="mwd_fuelLiter" data-in-click="getHistory:fuel" data-in-if="!vm.isFuelHidden()">
                        <span id="dial_fuel_val"></span><span>%</span>
                    </div>

                    <div className="mwd_fuelLiter -two" data-in-click="getHistory:fuel"  data-in-if="!vm.canIShowTemp(vehicle)">
                       <span data-in-if="!vm.isEV(vehicle)"> <span  id="dial_fuel2_val"></span><span >%</span></span>
                    </div>

                    {/*Vehicle battery Raw*/}
                    <div className="mwd_vehicleBatteryRaw" data-in-click="getHistory:carbattery" title="AUX / Vehicle Battery Voltage">
                        <span id="dial_vehiclebattery_val"></span><span> v</span>
                    </div>

                    <div className="mwd_vehicleBatteryStatus" data-in-click="getHistory:carbattery" data-in-if="vm.isBatteryInfoAvailable(vehicle)">
                        <div className="mwd_vbs_content" data-in-if="vm.checkBatteryHealth(vehicle, 1)">
                            <div className="mwd_vbsc_head -red">VERY BAD</div>
                            <div className="mwd_vbsc_body">Replace the Battery</div>
                        </div>
                        <div className="mwd_vbs_content" data-in-if="vm.checkBatteryHealth(vehicle, 2)">
                            <div className="mwd_vbsc_head -orange">BAD</div>
                            <div className="mwd_vbsc_body">Get the Battery checked immediately</div>
                        </div>
                        <div className="mwd_vbs_content" data-in-if="vm.checkBatteryHealth(vehicle, 4)">
                            <div className="mwd_vbsc_head -yellow">AVERAGE</div>
                            <div className="mwd_vbsc_body">Good for one month with normal usage</div>
                        </div>
                        <div className="mwd_vbs_content" data-in-if="vm.checkBatteryHealth(vehicle, 6)">
                            <div className="mwd_vbsc_head -green">GOOD</div>
                            <div className="mwd_vbsc_body">Battery is in good condition</div>
                        </div>
                        <div className="mwd_vbs_content" data-in-if="vm.checkBatteryHealth(vehicle, -1)">
                            <div className="mwd_vbsc_head">NOT AVAILABLE</div>
                            <div className="mwd_vbsc_body">Battery Health info not available</div>
                        </div>
                    </div>


                    {/*Device battery Raw*/}
                    <div className="mwd_deviceBatteryRaw" data-in-click="getHistory:devbattery" title='AuX / Device Voltage'>
                        <span id="dial_devicebattery_val"></span><span className="-unit" id="dial_devicebattery_unit"> v</span>
                    </div>


                    <div  className="mwd-indicator -mwdi-ac" data-in-if="vm.checkHistoryAvailable(vehicle, 'ac')" data-in-click="getHistory:ac"></div>
                    <div className="mwd-indicator -mwdi-seatbelt" data-in-if="vm.checkHistoryAvailable(vehicle, 'seatbelt')" data-in-click="getHistory:seatbelt"></div>
                    <div className="mwd-indicator -mwdi-headlight" data-in-if="vm.checkHistoryAvailable(vehicle, 'headlight')" data-in-click="getHistory:headlight"></div>
                    <div className="mwd-indicator -mwdi-mil" data-in-if="vm.checkHistoryAvailable(vehicle, 'mil')" data-in-click = "getDtcReport">
                        <div className="mwdimil-box">
                            <span id="dial_millist">No MIL</span>
                        </div>
                    </div>


                    <div className="mwd-bg2"></div>
                    <div className="mwd-bg3"></div>

                    {/* odo, swapping cycle */}
                    <div className="mwd_odo" id="dial_odometer" data-in-click="getHistory:odo">
                        <div className="mwdo_item mwdoi-1">0</div>
                        <div className="mwdo_item mwdoi-2">0</div>
                        <div className="mwdo_item mwdoi-3">0</div>
                        <div className="mwdo_item mwdoi-4">0</div>
                        <div className="mwdo_item mwdoi-5">0</div>
                        <div className="mwdo_item mwdoi-6">0</div>
                        <div className="mwdo_item mwdoi-7">0</div>
                    </div>

                    <div className="mwd_timeindicator -gps"  data-in-class="--can:vm.showCANTime(),--kle:vm.showKLETime()"></div>
                    <div className="mwd_timeindicator -can"   data-in-if="!vm.showCANTime(vehicle) && !vm.showKLETime(vehicle)" data-in-class="active:vm.isCANTime()"></div>
                    <div className="mwd_timeindicator -can --can"   data-in-if="vm.showCANTime(vehicle)"></div>
                    <div className="mwd_timeindicator -can --kle"   data-in-if="vm.showKLETime(vehicle)"></div>
                    <div className="mwd_timeindicator -canOdo" data-in-class="active:vm.isCANOdo()"></div>

                    <div className="mwd_time" data-in-click="copyToClipboard"  data-in-if="!vm.showCANTime(vehicle) && !vm.showKLETime(vehicle)"><span id="dial_last_proctime"></span></div>
                    <div className="mwd_time" data-in-click="copyToClipboard"  data-in-if="vm.showCANTime(vehicle)"><span id="dial_can_proctime"></span></div>
                    <div className="mwd_time" data-in-click="copyToClipboard"  data-in-if="vm.showKLETime(vehicle)"><span id="dial_kle_proctime"></span></div>

                    <div className="mwd_gpstime" data-in-click="copyToClipboard" data-in-if="!vm.showCANTime(vehicle) && !vm.showKLETime(vehicle)"><span id="dial_gps_time"></span></div>
                    <div className="mwd_gpstime --can" data-in-click="copyToClipboard" data-in-if="vm.showCANTime(vehicle)"><span id="dial_can_time"></span></div>
                    <div className="mwd_gpstime --kle" data-in-click="copyToClipboard" data-in-if="vm.showKLETime(vehicle)"><span id="dial_kle_time"></span></div>

                    <div className="mwd_name -mwd_clickable">
                        <div data-in-click="copyToClipboard"><span id="dial_vehicle_vehicleno"></span></div>
                        <div data-in-click="copyToClipboard"><span id="dial_vehicle_model"></span></div>
                        <div data-in-click="copyToClipboard"><span id="dial_vehicle_fueltype"></span></div>
                        {/* <div data-in-click="copyToClipboard"><span id="dial_vehicle_transmission"></span></div> */}
                        <div data-in-click="copyToClipboard"><span id="dial_vehicle_variant"></span></div>
                    </div>
                    <div className="mwd_chassisname -mwd_clickable">
                        <div data-in-click="copyToClipboard"><span id="dial_vehicle_chassisno"></span></div>
                    </div>
                    <div className="mwd_devicename -mwd_clickable">
                        <div className="mwdd-kle" data-in-click="copyToClipboard" data-in-mouseenter="mouseEnter:KLE"  data-in-mouseleave="mouseLeave:KLE" data-in-if="vehicle.devices.LOCK_UNLOCK"><span id="dial_vehicle_kledeviceno"></span></div>
                        <div className="mwdd-can" data-in-click="copyToClipboard" data-in-mouseenter="mouseEnter:CAN" data-in-mouseleave="mouseLeave:CAN"><span id="dial_vehicle_deviceno"></span></div>
                    </div>

                    <div className="mwd_buttons -mwd_clickable">
                        <div data-in-click="showHistory" data-in-class="inactive:vm.checkReportDisabled('showHistory')"><i className="fa fa-line-chart"></i></div>
                        <div className="-red" data-in-click="mobilize:0" data-in-class="inactive:!vm.checkCmdPerm('immobilize'),-hide:vm.checkDisplayMode()">IMMOB</div>
                        <div className="-green" data-in-click="mobilize:1" data-in-class="inactive:!vm.checkCmdPerm('immobilize'),-hide:vm.checkDisplayMode()">MOB</div>
                        <div className="-green" data-in-click="shareLink" data-in-class="inactive:!vm.checkLocshareEnable()"><i className='fa fa-location-dot'></i></div>
                    </div>
                    <div className="mwd_buttons -mwd_clickable -second">
                        <div className="-green" data-in-click="lock:0" data-in-class="inactive:!vm.checkCmdPerm('lockunlock'),-hide:vm.checkDisplayMode()"><i className="fa fa-lock"></i></div>
                        <div className="-brightgreen" data-in-click="lock:1" data-in-class="inactive:!vm.checkCmdPerm('lockunlock'),-hide:vm.checkDisplayMode()"><i className="fa fa-unlock"></i></div>
                        <div className="-green"  data-in-click="honk" data-in-class="inactive:!vm.checkCmdPerm('honk'),-hide:vm.checkDisplayMode()"><img alt="" src={hornImg}/></div>
                        <div className="-green"  data-in-click="openSettings" data-in-class="-hide:vm.checkDisplayMode()"><i className="fa fa-cog"></i></div>
                    </div>

                </div>
               {/* <div data-in-class="inactive:false" style={{position:'absolute',top:238, left:320, zIndex:1000, width:70, height: 20, background:'#666',  }}><span>Link copied!</span></div> */}

                <div className="mwd_dummyBG"></div>
                <div className="mwd_graph" id="mwd_graph">
                    <div className="mwdg-loading" data-in-if="vm.graphStatus === 'LOADING'">loading</div>
                    <div className="mwdg-loading" data-in-if="vm.graphStatus === 'NODATA'">No Data</div>
                    <svg id="infovis" width="100%" height="100%"></svg>
                </div>
            </div>
        ));
    }
}


export default InfoWindow;